import { ReactComponent as CloseIcon } from './close.svg'

export default CloseIcon
